import { render, staticRenderFns } from "./TopNumber.vue?vue&type=template&id=518d70d2&scoped=true"
import script from "./TopNumber.vue?vue&type=script&lang=js"
export * from "./TopNumber.vue?vue&type=script&lang=js"
import style0 from "./TopNumber.vue?vue&type=style&index=0&id=518d70d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d70d2",
  null
  
)

export default component.exports